module.exports = function() {
  return new Worker(__webpack_public_path__ + "305b8a8d251eea0fc811.worker.js");
};